// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body.fullscreen-overlay .view-wrapper{overflow:hidden}`, "",{"version":3,"sources":["webpack://./client/components/Overlay.vue"],"names":[],"mappings":"AAGA,sCACE,eAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
